<template>
  <v-form ref="form">
    <v-row class="ma-0">
      <v-col cols="12">
        <h3>{{ $t('Informações gerais') }}</h3>
        <span>{{ $t('Preencha os campos para continuar') }}</span>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          :label="$t('Instituição de destino')"
          v-model="institutionName"
          :rules="[(v) => !!v || 'Campo obrigatório']"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="unidadeIds"
          multiple
          :items="unidades"
          item-text="name"
          item-value="id"
          append-icon="mdi-chevron-down"
          :label="$t('Unidades')"
          :search-input.sync="unitySearch"
          @blur="unitySearch = ''"
          placeholder="Todas"
        >
          <template v-slot:selection="{ attrs, index, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              color="#BBCF20"
              text-color="#fff"
              small
              @click="select"
              @click:close="removeUnidade(index)"
            >
              {{ item.name }}
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <span class="text-caption">
              {{ item.name }}
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="link"
          :label="$t('Sigla do link de acesso')"
          @keyup="link = link.replaceAll(' ', '').toUpperCase()"
          :rules="[
            (v) => !!v || 'Digite o link de acesso',
            (v) => !v.includes('/') || 'Link não pode incluir barras',
          ]"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="toCareUser.name"
          :label="$t('Aos cuidados')"
          :rules="[(v) => !!v || 'Digite o usuário']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="reviser.name"
          :label="$t('Revisor')"
          :rules="[(v) => !!v || 'Digite o revisor']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="reviser.userOffice"
          :label="$t('Cargo (Revisor)')"
          :rules="[(v) => !!v || 'Digite o cargo']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="reviser.cellPhoneNumber"
          :label="$t('Telefone (Revisor)')"
          :rules="[(v) => !!v || 'Digite o telefone']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-textarea
          v-model="lastEvents"
          :label="$t('Principais eventos do período')"
          :placeholder="$t('Descreva os principais eventos do período')"
          :rules="[(v) => !!v || 'Descreva os eventos acima']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="12" sm="6">
        <v-textarea
          v-model="nextEvents"
          :label="$t('Eventos previstos para o próximo mês')"
          :placeholder="$t('Descreva os eventos previstos para o próximo mês')"
          :rules="[(v) => !!v || 'Descreva os eventos acima']"
        >
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-textarea>
      </v-col>

      <v-col cols="12">
        <v-card-actions class="justify-space-between">
          <v-spacer></v-spacer>

          <v-btn text @click="submit">
            {{ $t('Continuar') }}
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
export default {
  name: 'SelectInstStep',

  props: {
    generalInfo: Object,
    step: Number,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    await this.getUsers()
    await this.getUnidades()
  },

  watch: {
    generalInfo() {
      if (!!this.generalInfo && Object.keys(this.generalInfo).length > 0) {
        this.unidadeIds = this.generalInfo.unidadeIds
        this.reviser.name = this.generalInfo.reviser.name
        this.reviser.userOffice = this.generalInfo.reviser.userOffice
        this.reviser.cellPhoneNumber = this.generalInfo.reviser.cellPhoneNumber
        this.institutionName = this.generalInfo.institutionName
        this.toCareUser.name = this.generalInfo.toCareUser.name
        this.lastEvents = this.generalInfo.lastEvents
        this.nextEvents = this.generalInfo.nextEvents
        this.link = this.generalInfo.link
      } else {
        this.unidadeIds = []
        this.reviser.name = ''
        this.reviser.userOffice = ''
        this.reviser.cellPhoneNumber = ''
        this.institutionName = ''
        this.toCareUser.name = ''
        this.lastEvents = ''
        this.nextEvents = ''
        this.link = ''
      }
    },
  },

  data() {
    return {
      unitySearch: '',
      link: '',
      apiService: new ApiService(),
      institution: {},
      users: [],
      lastEvents: null,
      nextEvents: null,
      reviser: {},
      toCareUser: {},
      unidadeIds: [],
      unidades: [],
      institutionName: '',
    }
  },

  methods: {
    removeUnidade(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },

    submit() {
      let link = this.link

      if (!link.includes(this.institution.initials + '-')) {
        link = this.institution.initials + '-' + this.link
      }

      if (this.$refs.form.validate()) {
        this.$emit('next', {
          unidadeIds: this.unidadeIds,
          reviser: this.reviser,
          institutionName: this.institutionName,
          toCareUser: this.toCareUser,
          lastEvents: this.lastEvents,
          nextEvents: this.nextEvents,
          link: link,
        })
      }
    },

    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getUsers() {
      await this.apiService
        .get(`user/list/${this.institution.id}`)
        .then((response) => {
          this.users = response.content
        })
    },
  },
}
</script>

<style scoped></style>
